module.exports = __webpack_public_path__ + "static/media/film-director.285474d0.jpg";